import React from "react"
import autobind from "class-autobind"
import ImageLoader from "../../../components/misc/ImageLoader"
import ToolTip from "react-portal-tooltip"
import strings from "../../../localization/strings"
import { IUserDocument } from "../../../models"

interface IProps {
    employee: IUserDocument
    index: number
}
interface IState {
    open: boolean
}

export default class EmployeeNameColumn extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            open: false
        }
        autobind(this)
    }

    openPopup() {
        this.setState({ open: true })
    }

    closePopup() {
        this.setState({ open: false })
    }

    render() {
        const toolTip = (
            <div>
                <ToolTip
                    active={this.state.open}
                    position="left"
                    arrow="center"
                    parent={"#" + "image-" + this.props.index}
                    key={this.props.index}
                    group={"image-" + this.props.index}
                    tooltipTimeout={50}
                >
                    {this.props.employee && this.props.employee.ProfileImageS3Url ? (
                        <div style={{ height: 250, minWidth: 150 }}>
                            <ImageLoader url={this.props.employee.ProfileImageS3Url} fixedHeight={250} />
                        </div>
                    ) : (
                        <div style={{ height: 75, minWidth: 150 }}>
                            <div
                                style={{
                                    width: 320,
                                    height: 75,
                                    textAlign: "center"
                                }}
                            >
                                <h3>{strings.No_image}</h3>
                                <p>{strings.This_employee_has_not_image}</p>
                            </div>
                        </div>
                    )}
                </ToolTip>
                <span onMouseOver={this.openPopup} onMouseOut={this.closePopup} id={"image-" + this.props.index}>
                    {this.props.employee && this.props.employee.FirstName + " " + this.props.employee.LastName}
                </span>
            </div>
        )

        return <div className="EmployeeNameColumn">{toolTip}</div>
    }
}
